import React from "react";
import { useDispatch, useSelector } from "react-redux";
import RightOptions from "./RightOptions";
import { Content, NavbarTitle } from "./style";
import { clearToken } from "../../redux/modules/auth/actions";
import CustomInput from "../FormElement/Search";
import { GoArrowLeft } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";

export default () => {
  const dispatch = useDispatch();
  const { username } = useSelector((state) => state.authReducer);
  const handleLogout = () => {
    dispatch(clearToken());
  };
  const navigate = useNavigate();
  const location = useLocation();

  const backLoyiha = () => {
    navigate("/projects");
  };

  const isLoyihaAddPage = location.pathname === "/projects/form";

  return (
    <Content>
      {isLoyihaAddPage ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "23px",
          }}
        >
          <GoArrowLeft
            cursor={"pointer"}
            size={30}
            onClick={backLoyiha}
            color="#343C6A"
          />
          <NavbarTitle>Loyiha qo‘shish</NavbarTitle>
        </div>
      ) : (
        <CustomInput
          type="search"
          prefix={<CiSearch color="#8490A5" fontWeight="400" />}
          placeholder={"| Qidiruv"}
          height="40px"
          width="444px"
        />
      )}

      <RightOptions handleLogout={handleLogout} user={username} />
    </Content>
  );
};
